// src/components/watchDetail/ParticipantSection/LeaderBoard.js
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Trophy } from "lucide-react";
import "./LeaderBoard.css";
import CryptoIconWrapper from "../../../cryptoicons/CryptoIconWrapper";

const LeaderBoard = ({ participants }) => {
  const topBettors = useMemo(() => {
    return [...participants]
      .sort((a, b) => b.bet - a.bet)
      .slice(0, 10)
      .map((participant, index) => ({
        ...participant,
        rank: index + 1,
      }));
  }, [participants]);

  const getRankStyle = (rank) => {
    switch (rank) {
      case 1:
        return {
          backgroundColor: "rgba(255, 215, 0, 0.1)",
        };
      case 2:
        return {
          backgroundColor: "rgba(192, 192, 192, 0.1)",
        };
      case 3:
        return {
          backgroundColor: "rgba(205, 127, 50, 0.1)",
        };
      default:
        return {};
    }
  };

  if (!participants?.length) {
    return <div className="leaderboard-empty">No participants yet</div>;
  }

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-list gap-3 flex flex-col">
        {topBettors.map((bettor) => (
          <div
            key={bettor.address}
            className="leaderboard-item"
            style={getRankStyle(bettor.rank)}
          >
            <div className="rank-info">
              {bettor.rank <= 3 ? (
                <Trophy size={16} className={`trophy rank-${bettor.rank}`} />
              ) : (
                <span className="rank-number">#{bettor.rank}</span>
              )}
            </div>

            <div className="bettor-info">
              <div className="bettor-avatar">
                <img
                  src={bettor.avatar}
                  alt={`Rank ${bettor.rank}`}
                  loading="lazy"
                />
              </div>
              <div className="bettor-details">
                <span className="bettor-address">{bettor.address}</span>
                <div className="bet-info">
                  <CryptoIconWrapper name={bettor.token.toLowerCase()} size={14} />
                  <span className="bet-amount">
                    ${bettor.bet.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

LeaderBoard.propTypes = {
  participants: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
      bet: PropTypes.number.isRequired,
      token: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default LeaderBoard;
